import { validate, minLength } from './validator_utils'

export const postCreateValidator = async (data) => {
    const rules = {
        title: minLength(5, 'Preencha o título'),
        post: minLength(10, 'Digite o conteúdo do post'),
        selectedcategories: minLength(1, 'Selecione ao menos uma categoria'),
    }
    return validate(data, rules)
}

export const postUpdateValidator = postCreateValidator
